import { render, staticRenderFns } from "./ContractDetailComponent.vue?vue&type=template&id=7c84e068&"
import script from "./ContractDetailComponent.vue?vue&type=script&lang=js&"
export * from "./ContractDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports